import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import '../../assets/css/pages/track_progress/ngss-dimensions-row.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faChevronRight, faLeaf, faUsers, faDna, faQuestion, faCloud } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
library.add(faLeaf, faDna, faUsers, faQuestion, faCloud, faChevronRight)

const NgssDimensionsRow = props =>{
  const { sectionTitle, isContainerExpanded, showSectionTitle, title, dimensionType, percentage, tickCount } = props

  return(
    <div className='ngss-dimensions-row'>
      {sectionTitle && isContainerExpanded && <div className='section-title'>{sectionTitle}</div>}
      <div className='chart-container'>
        <div className='vertical-dividers'>
          {_.map(new Array(tickCount), (i,index) => <span key={`ngss-dimensions-row-${index}`} className='vertical-divider'/>)}
        </div>
        <div className='title'>{title}</div>
        <div className={`bar ${dimensionType}`}>
          <div style={{ right: `${(1 - percentage)*100}%` }} className={`fill ${dimensionType}`}></div>
        </div>
      </div>
    </div>
  )
}

NgssDimensionsRow.defaultProps = {
  tickCount: 10
}

export default NgssDimensionsRow
